<div class="PolicyDashboard">
  <div class="Loading" *ngIf="isShowLoading==true">
    <img id="" src="assets/img/762.gif" />
    <label>{{'Please Wait,Processing..'|translate }}</label>
  </div>
  <div class="Container-fluid">
    <div class="ChartsList">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="ChartDiv first">
            <div class="Title">
              <span class="CardTitle">{{'Motor Insurance' |translate}}</span>
            </div>
            <div class="PolicyDescrption">
              <div class="row">
                <div class="col-lg-3 col-sm-3 col-xs-3 col-md-3 cariconarabic">
                  <div class="CarIcon">
                    <i class="fa fa-car"></i>
                  </div>
                </div>
                <div class="col-lg-9 col-sm-9 col-xs-9 col-md-9">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>
                        <span (click)="MotorPolicies('T')">{{'Total No. of Policies' | translate }}</span>
                        <span>{{motorPolicyDashboard.TotalPolicies}}</span>
                      </label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>
                        <span (click)="MotorPolicies('A')"> {{'Active Policies' |translate }}</span>
                        <span>{{motorPolicyDashboard.ActivePolicies}}</span>
                      </label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngIf="false">
                      <label>
                        <span (click)="MotorPolicies('P')"> {{'Pending Propsals' | translate }} </span>
                        <span>{{motorPolicyDashboard.PendingProposals}}</span>
                      </label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>
                        <span (click)="MotorPolicies('R')">{{'Policies due for Renewal' | translate }}</span>
                        <span>{{motorPolicyDashboard.ExpiredPolicies}}</span>
                      </label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>
                        <span (click)="MotorPolicies('C')">{{'Cancelled Policies' | translate }}</span>
                        <span>{{motorPolicyDashboard.CancelledPolicies}}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="ChartDiv second">
            <div class="Title">
              <span class="CardTitle">{{'Travel Insurance' | translate }}</span>
            </div>
            <div class="PolicyDescrption">
              <div class="row">
                <div class="col-lg-3 col-sm-3 col-xs-3 col-md-3">
                  <div class="CarIcon">
                    <i class="fa fa-plane"></i>
                  </div>
                </div>
                <div class="col-lg-9 col-sm-9 col-xs-9 col-md-9">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>
                        <span (click)="TravelPolicies('T')">{{'Total No. of Policies' |translate }}</span>
                        <span>{{travelPolicyDashboard.TotalPolicies}}</span>
                      </label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>
                        <span (click)="TravelPolicies('A')"> {{'Active Policies' | translate }}</span>
                        <span>{{travelPolicyDashboard.ActivePolicies}}</span>
                      </label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngIf="false">
                      <label>
                        <span> {{'Pending Proposals' | translate }} </span>
                        <span>{{travelPolicyDashboard.PendingProposals}}</span>
                      </label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>
                        <span (click)="TravelPolicies('')">{{'Policies due for Renewal' | translate }}</span>
                        <span>0</span>
                      </label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>
                        <span>{{'Cancelled Policies' | translate }}</span>
                        <span>0</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="ChartDiv Third">
            <div class="Title">
              <span class="CardTitle">{{'Medical Mal Practice' | translate }}</span>
            </div>
            <div class="PolicyDescrption">
              <div class="row">
                <div class="col-lg-3 col-sm-3 col-xs-3 col-md-3">
                  <div class="CarIcon">
                    <i class="fa fa-stethoscope"></i>
                  </div>
                </div>
                <div class="col-lg-9 col-sm-9 col-xs-9 col-md-9">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>
                        <span (click)="MedmalPolicies('T')">{{'Total No. of Policies' | translate}}</span>
                        <span>{{medmalPolicyDashboard.TotalPolicies}}</span>
                      </label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>
                        <span (click)="MedmalPolicies('A')"> {{'Active Policies' | translate }}</span>
                        <span>{{medmalPolicyDashboard.ActivePolicies}}</span>
                      </label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngIf="false">
                      <label>
                        <span (click)="MedmalPolicies('')"> {{'Pending Propsals' | translate }} </span>
                        <span>{{medmalPolicyDashboard.PendingProposals}}</span>
                      </label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>
                        <span>{{'Policies due for Renewal' | translate }}</span>
                        <span>0</span>
                      </label>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>
                        <span>{{'Cancelled Policies' | translate }}</span>
                        <span>0</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class=" ">
    <div class="row">
      <div class="col-md-12">
        <div class="card" id="InsuranceModel">
          <ul class="nav nav-tabs" role="tablist">
            <li id="tab1head" role="presentation" class="active">
              <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Motor'|translate}}</a>
            </li>
            <li id="tab2head" role="presentation">
              <a href="#profile" aria-controls="profile" role="tab" data-toggle="tab">{{'Travel'|translate}}</a>
            </li>
            <li id="tab3head" role="presentation">
              <a href="#messages" aria-controls="messages" role="tab" data-toggle="tab">{{'Medical Mal'|translate}}</a>
            </li>
            <!-- <li id="tab3head" role="presentation">
              <a href="#Domestic" aria-controls="Domestic" role="tab"
                data-toggle="tab">{{'Domestic Helper'|translate}}</a>
            </li> -->
          </ul>
          <div class="tab-content PolicyPage">
            <div role="tabpanel" class="tab-pane active" id="home">
              <div class="row">
                <div class="col-md-12 proposals">
                  <table class="table table-striped table-bordered table-list">
                    <thead>
                      <tr>
                        <th>{{'Policy No'|translate}}</th>
                        <th *ngIf="false">{{'Name'|translate}}</th>
                        <th>{{'Policy Issue Date' | translate }}</th>
                        <th>{{'Policy To Date'|translate}}</th>
                        <th>{{'Najm Status'| translate }}</th>
                        <th>{{'Policy Status'| translate }}</th>
                        <th>{{'Policy'|translate}}</th>
                        <th>{{'Status'|translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let policy of MotorPolicyList">
                        <td>{{policy.PolicyNo}}</td>
                        <td *ngIf="false">{{policy.InsName}}</td>
                        <td>{{policy.IssuedDate | date:'dd/MM/yyyy'}}</td>
                        <td>{{policy.PolicyToDate | date:'dd/MM/yyyy'}}</td>
                        <td>{{policy.NPSTATUS}}</td>
                        <td>{{policy.PolicyStatus}}</td>
                        <td>

                          <!-- <a  [ngClass]="IsMotor ? 'Motorlbl' :IsTravel ? 'Travellbl':IsMedMal ? 'Medicallbl': IsHome ? 'Homelbl':none"
                            href="https://ubc.ggi-sa.com/LIMRA_REPORTS_UAT/MOTOR/DL1.aspx?strParm={{policy.NPID}}"
                            download="myPolicy" target="_blank"
                            *ngIf="policy.PolicyStatus=='ACTIVE'">{{'Download' | translate}}</a> -->
                          <a class="btn btn-primary" href="{{url.PrintURL}}/MOTOR/DL1.aspx?strParm={{policy.NPID}}"
                            download="myPolicy" target="_blank" *ngIf="policy.PolicyStatus=='ACTIVE'">{{'Download' |
                            translate}}</a>

                        </td>
                        <td>

                          <!-- TempComment Start -->
                          <!-- <button class="btn btn-primary" id="btnRenew" name="btnRenew"
                            *ngIf="policy.reStatus=='R' && (policy.EndorsementStatus=='CLOSED'|| policy.EndorsementStatus=='') "
                            (click)="goForRenew(policy)">{{'Renew' | translate}}</button> -->
                          <button class="btn btn-primary" id="btnCancel" name="btnCancel"
                            (click)="Motor_Cancellation(policy)" *ngIf="policy.EndorsementNo==''">{{'Cancel Policy'|
                            translate}}</button>
                          <!-- <button class="btn btn-primary" id="btnUpgrade" name="btnUpgrade"
                            *ngIf="policy.Productcode=='5515' && policy.IsEligibleForUpgrade=='1' && (policy.EndorsementStatus=='CLOSED'|| policy.EndorsementStatus=='')"
                            (click)="goForUpgrade(policy)">{{'Upgrade' | translate}}</button> -->
                          <button class="btn btn-primary" id="btnCancellationDetails" name="btnCancellationDetails"
                            (click)="CancellationDetails(policy)" *ngIf="policy.EndorsementNo!=''">
                            <a data-toggle="modal" class="canceldetails" data-target="#myModal">{{'Cancellation
                              Details'| translate}}</a>
                          </button>
                          <button *ngIf="policy.renewObj.Vdtype=='3' && policy.PolicyStatus=='ACTIVE'"
                            class="btn btn-primary" id="btnAddSeqNo" name="btnAddSeqNo"
                            (click)="AddSequenceNo(policy)">{{'Add Sequence No' | translate}}</button>
                          <button *ngIf="policy.PolicyStatus=='ACTIVE'" class="btn btn-primary" id="btnAddDriver"
                            name="btnAddSeqNo" (click)="AddDrivers(policy)">{{'Add Drivers' | translate}}</button>

                          <!-- TempComment End -->

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div role="tabpanel" class="tab-pane" id="profile">
              <div class="row">
                <div class="col-md-12 proposals">
                  <table class="table table-striped table-bordered table-list">
                    <thead>
                      <tr>
                        <th>{{'Policy No'|translate}}</th>
                        <th *ngIf="false">{{'Name'|translate}}</th>
                        <th>{{'Policy From Date'|translate}}</th>
                        <th>{{'Policy To Date'|translate}}</th>
                        <th>{{'Policy'|translate}}</th>
                        <th>{{'Policy'|translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let travelpolicy of TravelPolicyList">
                        <td>{{travelpolicy.PolicyNo}}</td>
                        <td *ngIf="false">{{travelpolicy.InsuredName}}</td>
                        <td>{{travelpolicy.PolicyFrom | date:'dd/MM/yyyy'}}</td>
                        <td>{{travelpolicy.PolicyTo | date:'dd/MM/yyyy'}}</td>
                        <td>
                          <!-- <a [ngClass]="IsMotor ? 'Motorlbl' :IsTravel ? 'Travellbl':IsMedMal ? 'Medicallbl': IsHome ? 'Homelbl':none"
                            href="https://b2c.ggi.com.sa/Reports/#/Travel/{{travelpolicy.QueryString}}"
                            download="myPolicy" target="_blank">Download</a> -->
                          <a href="{{url.PrintURL}}TRAVEL/rpt_PolicyPrint_TRAVEL.aspx?strParm={{travelpolicy.ProposalNo}}"
                            target="_blank">Download</a>
                        </td>
                        <td *ngIf="false">
                          <button class="btn btn-primary" id="btnRenew" name="btnRenew"
                            [disabled]="policy.reStatus!='R'" (click)="goForRenew(policy)">{{'Renew' | translate
                            }}</button>
                        </td>
                        <td>


                          <button class="btn btn-primary" id="btnCancel" name="btnCancel"
                            (click)="TravelAddEndorsement(travelpolicy)" *ngIf="travelpolicy.PolicyStatus=='A'">{{'Edit
                            Policy'| translate}}</button>

                          <button class="btn btn-primary" id="btnCancel" name="btnCancel"
                            (click)="TravelCancellation(travelpolicy)" *ngIf="travelpolicy.PolicyStatus=='A'">{{'Cancel
                            Policy'| translate}}</button>
                          <button class="btn btn-primary" id="btnCancellationDetailsTravel"
                            name="btnCancellationDetails" (click)="CancellationDetailsTravel(travelpolicy)"
                            *ngIf="travelpolicy.EndorsementId!=''">
                            <a data-toggle="modal" class="canceldetails" data-target="#myModalTravel">{{'Cancellation
                              Details'| translate}}</a>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div role="tabpanel" class="tab-pane" id="messages">
              <div class="row">
                <div class="col-md-12 proposals">
                  <table class="table table-striped table-bordered table-list">
                    <thead>
                      <tr>
                        <th>{{'Policy No'|translate}}</th>
                        <th>{{'Policy Issue Date'|translate}}</th>
                        <th>{{'Policy From Date'|translate}}</th>
                        <th>{{'Policy To Date'|translate}}</th>
                        <th>{{'Status'|translate}}</th>
                        <th>{{'Download'|translate}}</th>
                        <th>{{'Renew'|translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let medpolicy of MedmalPolicyList">
                        <td>{{medpolicy.PolicyNo}}</td>
                        <td>{{medpolicy.PolicyIssueDate}}</td>
                        <td>{{medpolicy.PolicyFromDate}}</td>
                        <td>{{medpolicy.PolicyToDate}}</td>
                        <td [ngStyle]="StatusCss(medpolicy.PolicyStatus)">{{medpolicy.PolicyStatus}}</td>
                        <td><a class="btn btn-primary btn-sm" href="{{medpolicy.PolicyPrintLink}}"
                            target="_blank">{{'Download'|translate}}</a></td>
                        <td><button class="btn btn-primary" id="btnRenew" name="btnRenew"
                            *ngIf="medpolicy.Renewal=='Renew'" (click)="goForRenew(medpolicy)">{{'Renew' | translate
                            }}</button></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Domestic Helper Start -->
            <div role="tabpanel" class="tab-pane" id="Domestic">
              <div class="row">
                <div class="col-md-12 proposals">
                  <table class="table table-striped table-bordered table-list">
                    <thead>
                      <tr>
                        <th>{{'Policy No'|translate}}</th>
                        <th>{{'Policy Issue Date' | translate }}</th>
                        <th>{{'Policy To Date'|translate}}</th>
                        <th>{{'Policy Status'| translate }}</th>
                        <th>{{'Policy'|translate}}</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let policy of DomesticPoliciesList">
                        <td>{{policy.PolicyNo}}</td>
                        <td>{{policy.PolicyIssueDate}}</td>
                        <td>{{policy.PolicyToDate }}</td>
                        <td>{{policy.Policy_Status}}</td>
                        <td>
                          <a [ngClass]="IsMotor ? 'Motorlbl' :IsTravel ? 'Travellbl':IsMedMal ? 'Medicallbl': IsHome ? 'Homelbl':none"
                            href="{{url.PrintURL}}MOTOR/DL1.aspx?strParm={{policy.NPID}}" download="myPolicy"
                            target="_blank" *ngIf="policy.Policy_Status=='ACTIVE'">{{'Download' | translate}}</a>
                        </td>

                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- Domestic Helper End -->

          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="myModal" data-backdrop="static" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content" style="margin-bottom: 30px !important;">
      <div class="modal-header" style="background-color: rgb(44, 55, 144) !important;">
        <button type="button" class="close" data-dismiss="modal">X</button>
        <h4 class="modal-title logins" style="color: white;font-size: 14px !important;">
          {{'Cancellation Details' | translate }}</h4>
      </div>
      <div class="modal-body">
        <!-- <div class="Login"> -->
        <table class="table table-striped table-bordered table-list">
          <tr>
            <th class="cancellationtableheading" style="color: maroon;">{{'Cancellation Status'|translate}}</th>
            <td class="cancellationtabledata" style="color: white; background-color: maroon ;font-weight: bold;">
              {{objCancellationDet.EndorsementStatus}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Policy No'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.PolicyNo}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Endorsement ID'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.EndorsementNo}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Request Date'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.EndorsementDate}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Cancellation Approval Date'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.EndorsementDecisionDate}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Refund Amount'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.RefundAmountExcVat}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'VAT On Refund Amount'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.VatOnRefundAmount}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Total Refund Amount'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.RefundAmount}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Cancellation Reason'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.CancellationReason}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Mobile Number'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.MobileNo}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'IBAN Number'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.IbanNo}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Bank Name'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.BankName}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Insured Name English'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.InsuredName_En}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Insured Name Arabic'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.InsuredName_Ar}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Plate Number'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.PlateNo}}</td>
          </tr>
          <!-- <tr>
            <th class="cancellationtableheading">{{'Yakeen Status'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.InsuredName_En}}</td>
          </tr> -->
          <tr>
            <th class="cancellationtableheading">{{'Used Days'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.UsedDays}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Remaining Days'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationDet.RemainingDays}}</td>
          </tr>
        </table>
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>







<div class="modal fade" id="myModalTravel" data-backdrop="static" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content" style="margin-bottom: 30px !important;">
      <div class="modal-header" style="background-color: rgb(44, 55, 144) !important;">
        <button type="button" class="close" data-dismiss="modal">X</button>
        <h4 class="modal-title logins" style="color: white;font-size: 14px !important;">
          {{'Cancellation Details' | translate }}</h4>
      </div>
      <div class="modal-body">
        <!-- <div class="Login"> -->
        <table class="table table-striped table-bordered table-list">
          <tr>
            <th class="cancellationtableheading" style="color: maroon;">{{'Cancellation Status'|translate}}</th>
            <td class="cancellationtabledata" style="color: white; background-color: maroon ;font-weight: bold;">
              {{objCancellationTravelDet.Decisionstatus}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Policy No'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationTravelDet.PolicyNo}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Endorsement ID'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationTravelDet.EndorsementId}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Request Date'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationTravelDet.EndorsementDate}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Cancellation Approval Date'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationTravelDet.DecisionDate}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Refund Amount'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationTravelDet.RefundPremium}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'VAT On Refund Amount'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationTravelDet.VATREFUNDAMOUNT}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Total Refund Amount'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationTravelDet.TotalRefundAmount}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Cancellation Reason'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationTravelDet.CanReasonDesc}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'IBAN Number'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationTravelDet.IBANNumber}}</td>
          </tr>
          <tr>
            <th class="cancellationtableheading">{{'Bank Name'|translate}}</th>
            <td class="cancellationtabledata">{{objCancellationTravelDet.BankDesc_Eng}}</td>
          </tr>

        </table>
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Policies/Policy.html